import axios from "./axios";
import qs from "qs";
import { Message } from "element-ui";
import { normalizeLegacyJsonFields } from "./legacyJsonFields";

function postWithJsonFields(path, data, schema) {
  try {
    const payload = normalizeLegacyJsonFields(data, schema);
    return axios.post("/node/" + path, qs.stringify(payload));
  } catch (error) {
    Message.error(error.message || "请求参数格式错误");
    return Promise.reject(error);
  }
}

export default {
  fetchPayOrders(params) {
    return axios.get("/node/fetchPayOrders", { params });
  },
  fetchPayOrdersByGroupIds(params) {
    return axios.get("/node/fetchPayOrdersByGroupIds", { params });
  },
  fetchPayOrder(params) {
    return axios.get("/node/fetchPayOrder", { params });
  },
  fetchPayOrderPurchaseRecords(params) {
    return axios.get("/node/fetchPayOrderPurchaseRecords", { params });
  },
  fetchPayOrderProductPriceHistory(params) {
    return axios.get("/node/fetchPayOrderProductPriceHistory", { params });
  },
  fetchPayOrderPurchaseMaterials(params) {
    return axios.get("/node/fetchPayOrderPurchaseMaterials", { params });
  },
  previewPayOrderFromPurchases(data) {
    return postWithJsonFields("previewPayOrderFromPurchases", data, { selectedList: "array" });
  },
  previewPayOrder(data) {
    return axios.post("/node/previewPayOrder", qs.stringify(data));
  },
  previewPayOrderGroup(data) {
    return axios.post("/node/previewPayOrderGroup", qs.stringify(data));
  },
  createPayOrderFromPurchases(data) {
    return postWithJsonFields("createPayOrderFromPurchases", data, { selectedList: "array" });
  },
  createPayOrder(data) {
    return axios.post("/node/createPayOrder", qs.stringify(data));
  },
  addOrUpdatePayOrder(data) {
    return axios.post("/node/addOrUpdatePayOrder", qs.stringify(data));
  },
  savePayOrderGroup(data) {
    return postWithJsonFields("savePayOrderGroup", data, { payOrderList: "array" });
  },
  deletePayOrder(data) {
    return axios.post("/node/deletePayOrder", qs.stringify(data));
  },
  deletePayOrderGroup(data) {
    return axios.post("/node/deletePayOrderGroup", qs.stringify(data));
  },
  fetchPayOrderStatusCounts(params) {
    return axios.get("/node/fetchPayOrderStatusCounts", { params });
  },
  updatePayOrderGroupStatus(data) {
    return axios.post("/node/updatePayOrderGroupStatus", qs.stringify(data));
  },
  voidPayOrderGroup(data) {
    return axios.post("/node/voidPayOrderGroup", qs.stringify(data));
  },
  updatePayOrderGroupAttachment(data) {
    return axios.post("/node/updatePayOrderGroupAttachment", qs.stringify(data));
  },
};
